import React from 'react';
import { bool, func } from 'prop-types';

import { SCBurger, BurgerLine, AttentionDot } from './styles';

Burger.propTypes = {
  attention: bool.isRequired,
  clicked: func.isRequired,
  open: bool.isRequired,
};

function Burger({ open, clicked, attention }) {
  return (
    <SCBurger onClick={clicked}>
      {attention && <AttentionDot open={open} />}
      <BurgerLine open={open} />
      <BurgerLine open={open} />
      <BurgerLine open={open} />
    </SCBurger>
  );
}

export default Burger;



// WEBPACK FOOTER //
// ./src/components/Burger/Burger.js